import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

import { changeFilter } from "app/store/dashboard/doctor_analytic/slice/doctorAnalyticSlice";
import { useDispatch, useSelector } from "react-redux";

const SortFilter = () => {
  const { sort } = useSelector((state) => state.doctorAnalytic);
  const dispatch = useDispatch();

  return (
    <>
      <FormControl fullWidth>
        <InputLabel id="sort-select-label">Sort</InputLabel>

        <Select
          labelId="sort-select-label"
          id="sort-select-helper"
          value={sort}
          label="sort"
          onChange={(e) => {
            dispatch(
              changeFilter({
                type: "sort",
                value: e.target.value,
              })
            );
          }}
        >
          <MenuItem value="highest">Highest reports signed</MenuItem>
          <MenuItem value="lowest">Lowest reports signed</MenuItem>
        </Select>
      </FormControl>
    </>
  );
};

export default SortFilter;
